<template>
    <div class="thumbnail__actions">
        <div class="thumbnail__more-info-button" @click="showCourseInfo" tabindex="0" @keyup.enter="showCourseInfo">
            <span :class="{ 'icon-chevron-up': !showMoreInfo, 'icon-chevron-down': showMoreInfo }"></span>
            <span v-html="getMoreInfoText"></span>
        </div>
        <div class="thumbnail__right-side-button">
            <TotemAddToWatchlistButton
                v-if="showAddToFavourite"
                :type="itemType"
                alignment="bottom"
                :elementId="entity.id"
            />
            <span
                @click="createCertificate"
                @keyup.enter="createCertificate"
                contextmenu=""
                class="icon-document-certificate"
                v-if="showCertificateIcon"
                v-tooltip="{ content: $t('Certificates.icon_tooltip'), html: true }"
                tabindex="0"
            >
            </span>
            <TotemHideOrRestoreCourse
                :course="entity"
                v-if="isUnCompletedView && itemType === 'course'"
                @hide-course="hideCourse"
            />
            <TotemHideOrRestoreLearningPath
                :learningPath="entity"
                v-if="isUnCompletedView && itemType === 'learningPath'"
                @hide-learning-path="hideLearningPath"
            />
        </div>
        <ModalHideCourse :course="entity" />
        <ModalHideLearningPath :learningPath="entity" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import ModalHideCourse from 'components/shared/modals/ModalHideCourse'
    import ModalHideLearningPath from 'components/shared/modals/ModalHideLearningPath'

    export default {
        name: 'thumbnail-actions',
        components: { ModalHideCourse, ModalHideLearningPath },
        data () {
            return {
                showMoreInfo: false
            }
        },
        props: {
            entity: {
                type: Object
            },
            isCompletedView: {
                type: Boolean
            },
            isUnCompletedView: {
                type: Boolean
            },
            isWatchListItem: {
                type: Boolean
            },
            itemType: {
                type: String,
                default: 'course'
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn'
            }),
            showCertificateIcon () {
                return !this.isWatchListItem && this.isCompletedView
            },
            showAddToFavourite () {
                return this.isLoggedIn && !this.isWatchListItem && !this.isCompletedView && !this.isUnCompletedView
            },
            getMoreInfoText () {
                return this.showMoreInfo ? this.$t('General.less_info') : this.$t('General.more_info')
            }
        },
        methods: {
            showCourseInfo () {
                this.$emit('show-course-info')
                this.showMoreInfo = !this.showMoreInfo
            },
            createCertificate () {
                this.$store.dispatch('Certificates/createCertificate', this.entity.certificate)
            },
            hideCourse(courseId) {
                this.$modal.show('hide-course-modal' + courseId)
            },
            hideLearningPath(learningPathId) {
                this.$modal.show('hide-learning-path-modal' + learningPathId)
            }
        }
    }
</script>

<style lang="scss">
.thumbnail {
    &__actions {
        min-height: 35px;
        display: flex;
        color: $astral;
        font-family: Nunito-ExtraBold, sans-serif;
        width: 100%;
        flex-direction: row;
        margin-top: auto;
        align-items: center;

        .icon-document-certificate {
            font-size: 2.6rem;
        }
    }

    &__more-info-button {
        font-size: 1.4rem;
        width: 82%;
        height: 100%;
        padding: 0 10px;
        justify-content: flex-start;
        display: flex;
        align-items: center;
        z-index: 600;
        flex-basis: 50%;
        border-radius: 0 0 0 4px;

        span {
            line-height: 35px;
        }

        &:hover {
            background-color: $concrete;
            cursor: pointer;
        }

        .icon-chevron-up,
        .icon-chevron-down {
            font-size: 2.9rem;
        }
    }

    &__right-side-button {
        width: 18%;
        height: 100%;
        justify-content: flex-end;
        display: flex;
        align-items: center;
        margin: 0 10px 0 0;
        flex-basis: 50%;
        z-index: 1;
    }
}
</style>
